import React, { useEffect, useRef, useState } from 'react'
import { Miniapptopbar } from '../HomeUser/components';
import { Search } from '../components/Header/components'
import { Retrieve_personal_info, getS3fullpath_withbucketname, iconwrapper } from '../../../config/commonfunctions';
import { ABBREVCITY_CURRENCY_MAP, ABBREV_PRESENCELOC_MAP, EMPTY, HOME_COLLECTION_VENDORTYPE_WEDDING, IMG_ALT, PROJECTGALLERY_FILTER_WEDDING, READABLE_PREACTUAL_MAP, READABLE_VENDORTYPE_MAP, TIER_DIAMOND_POSITION } from '../../../config/constants';
import { Checkdevicedetail, Loading, Portalmodal, Projectcard, ScreenHeight, ScreenWidth, refresh } from '../../../components';
import { USER_CHANGE_LOC, USER_PL_FIRST_READ_ALL, USER_PL_FIRST_READ_VTS, USER_PL_APPLYFILTER, USER_PL_SAVESETTINGSE, USER_PL_SAVESETTINGSW, PROJECT_INTERFACE_INFINITESCROLL_DATA, PROJECT_READ_ALLONCE, PROJECT_SAVESETTINGS } from '../../../config/api';
import { ProjectgalleryFilterModalContent } from '../components';
import { BOARD_ICON, FILTERTHIN_ICON } from '../../../config/svgicons';
import axios from 'axios'
import './ProjectGallery.css'

const filter_portalmidcss_web = {
    width: 600,
    height: 660,
    top: 'calc( 50% - 330px )',
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
}

const filter_portalmidcss_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none'
}

const filter_portalmidcsswtlarger_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
    overflowX: 'scroll'
}

function ProjectGallery(props) {

    // for background only
    useEffect(() => {
        let previousbgcolor = ""
        let previousBgimage = ""

        document.body.style.backgroundColor = 'var(--bodypink)'
        document.body.style.backgroundImage = 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'
        return () => {
            document.body.style.backgroundColor = previousbgcolor || '';
            document.body.style.backgroundImage = previousBgimage || '';
        };
    }, [])

    const device = Checkdevicedetail()
    const screen_width = ScreenWidth()
    const screen_height = ScreenHeight()
    const { token } = Retrieve_personal_info()

    const [loading, setLoading] = useState(false)
    const [selectedvt, setSelectedvt] = useState('')
    const [selectedwedorevent, setSelecteedwedorevent] = useState('')
    const [selecteditem, setSelecteditem] = useState(null)
    const [abbrev_locations, setAbbrev_locations] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [scrolltop, setScrolltop] = useState(-1)

    // from first api call
    const [abbrev_userlocation, setAbbrev_userlocaation] = useState('')
    const [loc, setLoc] = useState('')
    const [totalpl, setTotalpl] = useState(0)
    const [batches, setBatches] = useState([])
    const [numbatch, setNumbatch] = useState(-1)
    const [totalfilternum, setTotalfilternum] = useState(0)
    const [totalpricenum, setTotalpricenum] = useState(0)

    // from second and subsequent api call
    const [data, setData] = useState([])

    // portal
    const [showprice, setShowprice] = useState(false)
    const [showfilter, setShowfilter] = useState(false)
    const [showlocation, setShowlocation] = useState(false)

    // filters
    const [filtersetting, setFiltersetting] = useState({})

    const [availablefilterposition, setAvailablefilterposition] = useState([0, 6]) // 13, 30, 34
    const [availablefilterheaders, setAvailablefilterheaders] = useState(['Location', 'Guest Count']) //'Styles', 'Settings', 'Themes',
    const [tagfilter, setTagfilter] = useState([])
    const [locationfilter, setLocationfilter] = useState([])
    const [guestcountfilter, setGuestcountfilter] = useState([])
    const [filtergate, setFiltergate] = useState([]) // [Location, Guest count, Tags], use to determine which api to use

    // sldier value
    const [currency, setCurrency] = useState(EMPTY)
    const [rangereset, setRangereset] = useState(false)

    // refs for scroll handler to avoid stale closures
    const isFetchingBatchRef = useRef(false)
    const numbatchRef = useRef(-1)
    const batchesRef = useRef([])
    const scrollTimerRef = useRef(null)

    const fetchItems = () => {
        try {

            const obtainbatchesdata = (arr, max) => {
                let data = [];
                for (let i = 0; i < arr.length; i += max) {
                    data.push(arr.slice(i, i + max));
                }
                return data.slice()
            }

            var filter_gate_bits = ''
            for (let i = 0; i < filtergate.length; i++) {
                var curr_bit = +filtergate[i] // convert filter_gate to 1 and 0s
                filter_gate_bits = filter_gate_bits + curr_bit
            }

            axios({
                method: 'POST',
                url: PROJECT_READ_ALLONCE,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
            })
                .then((result) => {
                    const { data, status } = result
                    const { error, items } = data
                    if (status === 200 && error === false) {
                        const { projectinterface_ids, filterproject_w, rendercard_count, location , abbrev_userlocation} = items
                        setFiltersetting(JSON.parse(JSON.stringify(filterproject_w)))
                        setLoc(location)
                        setAbbrev_userlocaation(abbrev_userlocation)
                        setBatches(obtainbatchesdata(projectinterface_ids, rendercard_count))
                        setTotalfilternum(
                            filterproject_w['All']['Event Type'].length +
                            filterproject_w['All']['Location'].length +
                            filterproject_w['All']['Guest Count'].length
                        )
                        setLoading(false)
                    }
                })
                .catch(e => { })
        }
        catch (e) {
            console.log(e)
        }
    }


    useEffect(() => {
        setLoading(true)

        fetchItems()

        const handleScroll = () => {
            clearTimeout(scrollTimerRef.current)
            scrollTimerRef.current = setTimeout(() => {
                const nearBottom =
                    window.innerHeight + window.scrollY >= document.body.offsetHeight - 200

                if (nearBottom && !isFetchingBatchRef.current && numbatchRef.current < batchesRef.current.length - 1) {
                    isFetchingBatchRef.current = true
                    setNumbatch(prev => prev + 1)
                }
            }, 300) // waits 300ms after user stops scrolling
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // keep refs in sync with state
    useEffect(() => { numbatchRef.current = numbatch }, [numbatch])
    useEffect(() => { batchesRef.current = batches }, [batches])

    useEffect(() => {
        if (batches.length > 0 && numbatch === -1) {
            setNumbatch(0)  // trigger initial load only after batches is ready
        }
    }, [batches])

    useEffect(() => {
        if (numbatch > -1 && batches.length > 0) {
            const projectinterface_ids = batches[numbatch]
            setData(prev => [...prev, ...projectinterface_ids])  // ✅ functional update, no stale closure
            isFetchingBatchRef.current = false      // ✅ unblock next scroll trigger
        }
    }, [numbatch])

    const MOBILE_FILTER_ROOT = (
        <div style={{ padding: '0px 10px 24px 10px', width: '100%', backgroundColor: '#fff1f4', backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)', boxSizing: 'border-box', fontFamily: 'Lato' }}>

            <div className='Vendor_mobilefiltersortvendorfoundroot'>
                <div className='Vendor_mobilefiltersortroot' style={{ gap: 15 }}>

                    {/* <button
                        className='Vendor_mobileheartbtn'
                        onClick={() => {
                            window.open('/board', '_blank');  // Open link in a new tab
                        }}
                    >
                        {iconwrapper(BOARD_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    </button> */}

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <button
                            className='Vendor_mobileheartbtn'
                            style={{ marginRight: 5 }}
                            onClick={() => { window.open('/board', '_blank'); }}
                        >
                            {iconwrapper(BOARD_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        </button>
                        <div
                            onClick={() => { window.open('/board', '_blank'); }}
                            style={{ display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: '1.05', cursor: 'pointer' }}
                        >
                            <div>Mood</div>
                            <div>Board</div>
                        </div>

                    </div>

                    <button
                        className='Vendor_mobilefilter'
                        onClick={() => {
                            document.body.style.overflow = 'hidden'
                            setShowfilter(true)
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', placeItems: 'center' }}>
                            {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21 })}
                        </div>

                        {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                    </button>

                </div>
            </div>

        </div>
    )

    const DESKTOP_FILTER_ROOT = (
        <div style={{ padding: '0px 20px 24px 20px', width: '100%', boxSizing: 'border-box', fontFamily: 'Lato' }}>

            <div className='Vendor_filterroot' style={{ maxWidth: 1320, margin: '0 auto' }}>
                <div className='Vendor_filtersortrow' style={{ placeItems: 'center', placeContent: 'center', gap: 15 }}>


                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <button
                            className='Vendor_filtersortbtnleftheart'
                            style={{ marginRight: 5 }}
                            onClick={() => { window.open('/board', '_blank'); }}
                        >
                            {iconwrapper(BOARD_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        </button>
                        <div
                            onClick={() => { window.open('/board', '_blank'); }}
                            style={{ display: 'flex', flexDirection: 'column', placeContent: 'center', lineHeight: '1.05', cursor: 'pointer' }}
                        >
                            <div>Mood</div>
                            <div>Board</div>
                        </div>

                    </div>

                    <button
                        className='Vendor_filtersortbtnleft'
                        style={{ margin: 0, gap: 5 }}
                        onClick={() => {
                            document.body.style.overflow = 'hidden'
                            setShowfilter(true)
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', placeItems: 'center' }}>
                            {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21 })}
                        </div>
                        {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                    </button>

                </div>
            </div>



        </div>
    )

    const apply = (filtersetting) => {


        setShowfilter(false)

        document.getElementById('app-root').style.overflowY = ''
        if (device === 'MOBILE') {
            document.body.style.position = ''
            document.documentElement.scrollTop = scrolltop
            setScrolltop(-1)
        }
        document.body.style.overflow = ''

        setLoading(true)
        setNumbatch(-1)
        setData([])
        setBatches([])

        try {
            axios({
                method: 'POST',
                url: PROJECT_SAVESETTINGS, //USER_PL_SAVESETTINGSE,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                data: { filtersetting }
            }).then((result) => {

                const { data, status } = result
                const { error } = data
                if (status === 200 && error === false) {
                    fetchItems()
                }

            })


        }
        catch (e) {
            // window.location = '/'
        }

    }

    const FILTER_PORTAL = <Portalmodal
        title={'Filter'}
        portaltype={'commonportal'}
        open={showfilter}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowfilter(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? filter_portalmidcss_web : screen_width > screen_height ? filter_portalmidcsswtlarger_mobile : filter_portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
    >
        <div className='Portalmodal_vtroot'>

            <ProjectgalleryFilterModalContent
                apply={apply}
                availablefilters={PROJECTGALLERY_FILTER_WEDDING}
                filtersetting={filtersetting}
                usertype={'Wedding'}
                priceorfilter={'FILTER'}
                selectedVendorType={'All'}
                reset={() => {

                }}
            />

        </div>
    </Portalmodal>

    const CARDS_MAIN = <div style={{ maxWidth: '100%', display: 'flex', placeItems: 'center', placeContent: 'center' }}>
        <div
            className="vendor-cardsroot"
            style={{ width: device === 'WEB' ? 1320 : '100%', padding: { WEB: '30px 0px', WTINBTW: '30px 0px', TABLET: '30px 0px', SMALLTABLET: '0px 0px', MOBILE: '0px 10px' }[device] }}
        >
            {(data && data.length > 0)
                ? (device === 'WEB' || device === 'TABLET' || device === 'WTINBTW' || device === 'SMALLTABLET')
                    ? data.map((item, index) => <Projectcard
                        {...props}
                        key={index}
                        item={item}
                        viewtype={1} // 0 : vendor viewing, 1 : user viewing
                        device={device === 'SMALLTABLET' ? 'TABLET' : device}
                    />)
                    : device === 'MOBILE'
                        ? data.map((item, index) => <Projectcard
                            {...props}
                            key={index}
                            item={item}
                            viewtype={1} // 0 : vendor viewing, 1 : user viewing
                            device={device}
                        />)
                        : data.map((item, index) => <Projectcard
                            {...props}
                            key={index}
                            item={item}
                            viewtype={1} // 0 : vendor viewing, 1 : user viewing
                            device={device}
                        />)
                : null}
        </div>
    </div>

    return !loading
        ? <div className='ProjectGallery_root'>
            <Miniapptopbar {...props} currentpage={'GALLERY'} abbrev_userlocation={abbrev_userlocation}/>
            <Search
                {...props}
                wrapperstyle={{ width: '100%', padding: '24px 10px', }}
            // wrapperstyle={{backgroundColor: '#fff1f4',width:'100%', padding:'24px 10px', backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'}}
            />
            {device === 'MOBILE' ? MOBILE_FILTER_ROOT : DESKTOP_FILTER_ROOT}
            {CARDS_MAIN}
            {FILTER_PORTAL}
        </div>
        : <Loading />


}

export default ProjectGallery